import React from 'react'
import PropTypes from 'prop-types'

import RaisedButton from 'material-ui/RaisedButton'

import TextParser from '../common/TextParser'

export default class AddLineItem extends React.Component {

  static propTypes = {
    onAddCancelled: PropTypes.func.isRequired,
    onItemChange: PropTypes.func.isRequired,
    onItemDelete: PropTypes.func,
    style: PropTypes.any,
    editMode: PropTypes.bool,
    name: PropTypes.string,
    foremansTarget: PropTypes.number,
    laborersTarget: PropTypes.number
  }

  constructor(props) {
    super(props)
    this.state = {
      name: this.props.name,
      foremansTarget: this.props.foremansTarget || 0,
      laborersTarget: this.props.laborersTarget || 0
    }
  }

  handleCancelTouchTapped = () => {
    this.props.onAddCancelled()
  }

  handleAddTouchTapped = () => {
    const validationResult = this.validateInput()
    if (validationResult.success) {
      this.props.onItemChange({
        name: this.state.name,
        foremansTarget: this.state.foremansTarget,
        laborersTarget: this.state.laborersTarget
      })
    }
    else {
      this.setState({
        validationError: validationResult.error
      })
    }
  }

  handleDeleteTapped = () => {
    this.props.onItemDelete()
  }

  validateInput = () => {
    if (!this.state.name) {
      return { error: 'Line item name is required' }
    }
    return { success: true }
  }

  handleKeyDown = event => {
    if (event.nativeEvent.keyCode === 13) {
      if (event.nativeEvent.shiftKey) {
        return true
      }
      else {
        event.preventDefault()
        this.handleAddTouchTapped()
        return false
      }
    } 
    return event.keyCode !== 13
  }

  handleNameChanged = event => {
    this.setState({
      name: event.target.value,
      validationError: null
    })
    // Adjust the rows of the input area to the number of lines entered.
    const tasks = TextParser.parse(event.target.value, false)
    this.nameInput.rows = tasks.length
  }

  handleForemanChanged = (e) => {
    const value = parseInt(e.target.value) || 0
    this.setState({
      foremansTarget: value,
      validationError: null
    })
  }

  handleLaborerChanged = (e) => {
    const value = parseInt(e.target.value) || 0
    this.setState({
      laborersTarget: value,
      validationError: null
    })
  }

  render() {
    return (
      <div style={{ ...styles.container, ...this.props.style }}>
        <div style={styles.content}>
          <div style={styles.nameContainer}>
            { !this.props.editMode &&
              <div style={styles.label}>Name</div>
            }
            <textarea
              style={{ ...styles.input, ...styles.nameInput }}
              type='text'
              rows={1}
              placeholder='Type line item(s) name(s), shift + enter for new line'
              ref={textarea => this.nameInput = textarea}
              value={this.state.name}
              onChange={this.handleNameChanged}
              onKeyDown={this.handleKeyDown} />
          </div>
          <div style={styles.foremanContainer}>
            { !this.props.editMode &&
              <div style={styles.label}>{'Foreman\'s target'}</div>
            }
            <input style={{ ...styles.input, ...styles.targetInput }}
              type='text'
              onChange={this.handleForemanChanged}
              value={this.state.foremansTarget} />
          </div>
          <div style={styles.laborContainer}>
            { !this.props.editMode &&
              <div style={styles.label}>{'Laborers\' target'}</div>
            }
            <input style={{ ...styles.input, ...styles.targetInput }}
              type='text'
              onChange={this.handleLaborerChanged}
              value={this.state.laborersTarget} />
          </div>
        </div>
        { this.state.validationError &&
          <div style={styles.validation}>
            { this.state.validationError }
          </div>
        }
        <div style={styles.actionsContainer}>
          <RaisedButton
            style={{ height: 32, width: 64 }}
            label='Cancel'
            labelColor='rgba(0,0,0,0.55)'
            labelStyle={{ textTransform: 'none' }}
            backgroundColor='rgba(0,0,0,0.05)'
            onTouchTap={this.handleCancelTouchTapped}/>
          <RaisedButton
            style={{ marginLeft: 8, height: 32, width: 64 }}
            label={this.props.editMode ? 'Save' : 'Add' }
            labelColor='#fff'
            labelStyle={{ textTransform: 'none' }}
            backgroundColor='#527da3'
            onTouchTap={this.handleAddTouchTapped} />
          { this.props.editMode &&
            <RaisedButton
              style={{ marginLeft: 48, height: 32, width: 64 }}
              label='Delete'
              labelColor='rgba(0,0,0,0.55)'
              labelStyle={{ textTransform: 'none' }}
              backgroundColor='rgba(0,0,0,0.05)'
              onTouchTap={this.handleDeleteTapped} />
          }
        </div>
      </div>
    )
  }

}

const styles = {

  container: {
    display: 'flex',
    flexDirection: 'column'
  },

  actionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 8
  },

  validation: {
    fontSize: 12,
    color: 'red',
    marginTop: 8
  },

  content: {
    display: 'flex',
    flexDirection: 'row'
  },

  nameContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    marginRight: 16
  },

  foremanContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: 16
  },

  laborContainer: {
    display: 'flex',
    flexDirection: 'column'
  },

  label: {
    color: '#757575',
    fontSize: 14
  },

  nameInput: {
    resize: 'vertical',
    maxHeight: 100
  },

  targetInput: {
    maxWidth: 100
  },

  input: {
    fontSize: 14,
    padding: '7px 11px 7px 11px',
    backgroundColor: '#fefefe',
    borderRadius: 3,
    marginTop: 6,
    boxShadow: 'inset 0 2px 2px 0 rgba(0, 0, 0, 0.05)',
    border: 'solid 1px rgba(0, 0, 0, 0.12)'
  }

}



// WEBPACK FOOTER //
// ./src/schedule/common/modules/lineItems/AddLineItem.js